import { designColors, designRadii } from "services/constants/designTokens";

export const filterToolbarButtonSx = {
  minHeight: 40,
  minWidth: 0,
  borderRadius: designRadii.control,
  textTransform: "none",
  fontSize: 13.5,
  fontWeight: 600,
  color: designColors.slate700,
  borderColor: designColors.slate200,
  backgroundColor: designColors.white,
  px: 1.5,
  "&:hover": { backgroundColor: designColors.slateBg, borderColor: designColors.slate300 },
  "&.Mui-disabled": { color: designColors.slate400, borderColor: designColors.slate100 },
};

export const filterToolbarSearchSx = {
  display: "flex",
  alignItems: "center",
  gap: 1,
  height: 40,
  minWidth: { xs: "100%", sm: 220 },
  flex: { xs: "1 1 100%", sm: "0 1 280px", md: "0 0 280px" },
  px: 1.5,
  borderRadius: designRadii.control,
  border: `1px solid ${designColors.slate200}`,
  backgroundColor: designColors.white,
  "&:hover": { borderColor: designColors.slate300 },
  "&:focus-within": { borderColor: designColors.slate400 },
};
